import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule, LinkModule } from '@com-delta-idp/mnx-ui-kit';
import { CardComponent } from './card.component';

@NgModule({
  declarations: [CardComponent],
  imports: [CommonModule, ImageModule, LinkModule],
  exports: [CardComponent]
})
export class CardModule {}
